import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import calendarIcon from "../assets/icons/ic_calendar_re.png";
import "./Calendar.scss";

const CalendarSection: React.FC = () => (
  <Box className="calendar-section">
    <Typography className="title upper-title">
      <img src={calendarIcon} alt="カレンダーアイコン" />
      カレンダー
    </Typography>
    <Paper>
      <Calendar
        locale="ja-JP"
        formatMonthYear={(locale, date) => `${date.getFullYear()}年${date.getMonth() + 1}月`}
        formatShortWeekday={(locale, date) => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()]}
        prev2Label={null}
        next2Label={null}
        formatDay={(locale, date) => date.getDate().toString()}
      />
    </Paper>
  </Box>
);

export default CalendarSection;
